import Button from "@material-ui/core/Button";
import React, {Component} from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {withStyles} from "@material-ui/core/styles";
//- konva
//import Konva from 'konva';
//import { Stage, Layer, Rect, Text, Image, Transformer } from 'react-konva';
import { Stage, Layer, Rect, Transformer, Image, Text } from 'react-konva';

import ReactResizeDetector from 'react-resize-detector';

//import goodJobSvg from '../../images/icons/goodJob.svg';
import truckImage from '../images/drawing/truck.png';
import trailerImage from '../images/drawing/trailer.png';
import carImage from '../images/drawing/car.png';
import useImage from 'use-image';

//import goodJobSvg from '../../images/icons/goodJob.svg';

import TruckIcon from '../images/icons/truckIcon.svg';
import AddTextIcon from '../images/icons/addTextIcon.svg';
import TrailerIcon from '../images/icons/trailerIcon.svg';
import EraserIcon from '../images/icons/eraserIcon.svg';
import PencilIcon from '../images/icons/pencilIcon.svg';
import SedanIcon from '../images/icons/sedanIcon.svg';
import DeleteIcon from '@material-ui/icons/Delete';


const TruckImage = () => {
	const [image] = useImage(truckImage);

	let width, height;
	if (image) {
		width = image.width * .25;
		height = image.height * .25;
	}

	return(
		<Image
			name='truck'
			x={50}
			y={20}
			width={width}
			height={height}
			image={image}
			draggable
		/>
	);
};

const TrailerImage = () => {
	const [image] = useImage(trailerImage);

	let width, height;
	if (image) {
		width = image.width * .25;
		height = image.height * .25;
	}

	return(
		<Image
			name='trailer'
			x={50}
			y={250}
			width={width}
			height={height}
			image={image}
			draggable
		/>
	);
};

const CarImage = () => {
	const [image] = useImage(carImage);

	let width, height;
	if (image) {
		width = image.width * .1;
		height = image.height * .1;
	}

	return(
		<Image
			x={100}
			y={50}
			name='car'
			width={width}
			height={height}
			image={image}
			draggable
		/>
	);
};

class Drawing extends Component {
	state = {
		hasDrawn : false,
		isDrawing: false,
	};

	componentDidMount() {
		const { stageWidth, stageHeight } = this.props;

		const canvas = document.createElement("canvas");
		canvas.width  = stageWidth;
		canvas.height = stageHeight;
		if (this.image) {
			this.image.width(stageWidth);
			this.image.height(stageHeight);
		}
		const context = canvas.getContext("2d");
		this.setState({ canvas, context });
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { stageWidth, stageHeight } = this.props;
		const { canvas, hasDrawn } = this.state;
		if (!canvas) { return; }

		if (
			stageWidth !== prevProps.stageWidth
			|| stageHeight !== prevProps.stageHeight

		) {

			//- If we have already drawn I can't resize the canvas because
			//- resizing a canvas clears it. Browser thing
			if (!hasDrawn) {
				canvas.width = stageWidth;
				canvas.height = stageHeight;
				if (this.image) {
					this.image.width(stageWidth);
					this.image.height(stageHeight);
				}
				//const context = canvas.getContext("2d");
				this.setState({canvas});
			}
		}
	}

	handleMouseDown = () => {
		this.setState({ isDrawing: true, hasDrawn : true });
		const stage = this.image.parent.parent;
		this.lastPointerPosition = stage.getPointerPosition();

		const thisImage = this;
		function handleOutsideMouseUp() {
			thisImage.setState({ isDrawing: false });
			window.removeEventListener('click', handleOutsideMouseUp);
		}

		window.addEventListener('mouseup', handleOutsideMouseUp);
		window.addEventListener('touchend', handleOutsideMouseUp);
	};

	handleMouseUp = () => {
		this.setState({ isDrawing: false });
	};

	handleMouseMove = () => {
		const { context, isDrawing } = this.state;
		const { brushMode } = this.props;
		if (!brushMode) { return; }

		if (isDrawing) {
			context.strokeStyle = "#333333";
			context.lineJoin = "round";

			if (brushMode === "draw") {
				context.globalCompositeOperation = "source-over";
				context.lineWidth = 5;
			} else if (brushMode === "erase") {
				context.lineWidth = 15;
				context.globalCompositeOperation = "destination-out";
			}
			context.beginPath();

			let localPos = {
				x: this.lastPointerPosition.x - this.image.x(),
				y: this.lastPointerPosition.y - this.image.y()
			};
			context.moveTo(localPos.x, localPos.y);

			const stage = this.image.parent.parent;
			const pos = stage.getPointerPosition();
			localPos = {
				x: pos.x - this.image.x(),
				y: pos.y - this.image.y()
			};
			context.lineTo(localPos.x, localPos.y);
			context.closePath();
			context.stroke();
			this.lastPointerPosition = pos;
			this.image.getLayer().draw();
		}
	};

	render() {
		const { canvas, brushMode} = this.state;
		if (!canvas) { return null; }
		const stroke = (brushMode) ? 'blue' : '#eeeeee';

		return (
			<Image
				image={canvas}
				ref={node => (this.image = node)}
				//width={stageWidth}
				//height={stageHeight}
				stroke={stroke}
				onMouseDown={this.handleMouseDown}
				onTouchStart={this.handleMouseDown}
				onMouseUp={this.handleMouseUp}
				onTouchEnd={this.handleMouseUp}
				onMouseMove={this.handleMouseMove}
				onTouchMove={this.handleMouseMove}
			/>
		);
	}

}

Drawing.propTypes = {
	stageWidth : PropTypes.number,
	stageHeight :  PropTypes.number,
	brushMode :  PropTypes.string,
};

class TransformerComponent extends React.Component {
	componentDidMount() {
		this.checkNode();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		this.checkNode();
	}
	checkNode() {
		// here we need to manually attach or detach Transformer node
		const stage = this.transformer.getStage();
		const { selectedShapeName } = this.props;

		const selectedNode = stage.findOne('.' + selectedShapeName);
		// do nothing if selected node is already attached
		if (selectedNode === this.transformer.node()) {
			return;
		}

		if (selectedNode) {
			// attach to another node
			this.transformer.attachTo(selectedNode);
		} else {
			// remove transformer
			this.transformer.detach();
		}
		this.transformer.getLayer().batchDraw();
	}
	render() {
		const enabledAnchors = (this.props.selectedShapeType === 'text')
			? ['middle-left', 'middle-right']
			: ['top-left', 'top-right', 'bottom-left', 'bottom-right'];

		const boundBoxFunc = (this.props.selectedShapeType === 'text')
			? (oldBox, newBox) => {
				newBox.width = Math.max(40, newBox.width);
				return newBox;
			}
			: (oldBox, newBox) => {
				return newBox;
			};

		return(
			<Transformer
				keepRatio={true}
				anchorSize={20}
				anchorFill={'rgba(18,137,212,.2)'}
				enabledAnchors={enabledAnchors}
				ref={node => {this.transformer = node;}}
				boundBoxFunc={boundBoxFunc}
				onTransform={() => {
					const selectedNode = this.transformer.node();
					if (selectedNode && selectedNode.getClassName() === 'Text') {
						selectedNode.setAttrs({
							width: selectedNode.width() * selectedNode.scaleX(),
							scaleX: 1
						});
					}
				}}
			/>
		);
	}
}

const styles = (theme) => {
	return {
		drawingContainer : {
			border : '1px solid #999',
			backgroundColor : 'white',
		},
		toolsContainer : {
			backgroundColor : '#e4e4e4',
			padding : 5,
			//height : 40,
			borderBottom : '1px solid #999',
			display : 'flex',
			flexDirection : 'row',
			flexWrap: 'wrap',
		},
		outlinedButton : {
			margin : 2,
			backgroundColor : 'white',
			[theme.breakpoints.down('sm')]: {
				minWidth : 50,
			},
		},
		containedButton : {
			margin : 2,
			[theme.breakpoints.down('sm')]: {
				minWidth : 50,
			},
		},
		stackedOutlinedButton : {
			//color : '#333',
			margin : 2,
			backgroundColor : 'white',
			lineHeight : 1,
			fontSize : 12,
			[theme.breakpoints.down('sm')]: {
				minWidth : 50,
			},
		},
		stackedContainedButton : {
			margin : 2,
			lineHeight : 1,
			fontSize : 12,
			color : 'white',
			[theme.breakpoints.down('sm')]: {
				minWidth : 50,
			},
		},
		icon : {
			height : 16,
			marginRight : 0,
			opacity : .8,
			[theme.breakpoints.up('sm')]: {
				marginRight : 5,
			},
		},
		invertedIcon : {
			height : 16,
			marginRight : 0,
			filter: 'invert(100%)',
			transform: 'scaleX(-1)',
			[theme.breakpoints.up('sm')]: {
				marginRight : 5,
			},
		},
		toolbarDivider : {
			borderRight : '1px solid #bbb',
			margin : '2px 10px',
		},
		toolButtonLabel : {
			display : 'none',
			[theme.breakpoints.up('sm')]: {
				display : 'inline'
			},
		}
	};
};

class AccidentDrawing extends Component {
	constructor(props) {
		super(props);

		this.state = {
			brushMode : '',
			stageWidth : null,
			stageHeight : 500,
			isTruckShowing : false,
			isTrailerShowing : false,
			isCarShowing : false,
			textboxes : [],
			selectedShapeName: '',
			selectedShapeType : '',
			uniqueKey : 'initialDraw'
		};
		this.baseState = this.state;
		this.props.setBase64StringFunction(this.getBase64String.bind(this));
	}

	componentDidMount() {
		this.checkSize();
	}

	checkSize = () => {
		const width = this.stageContainer.offsetWidth;
		const stageHeight = parseInt(width / 1.9, 10);

		this.setState({
			stageWidth: width,
			stageHeight,
		});
	};

	onResize = () => {
		this.checkSize();
	};

	handleStageMouseDown = e => {

		// clicked on stage - clear selection
		if (e.target === e.target.getStage()) {
			this.setState({
				selectedShapeName: '',
				selectedShapeType: '',
			});
			return;
		}
		// clicked on transformer - do nothing
		const clickedOnTransformer = e.target.getParent().className === 'Transformer';
		if (clickedOnTransformer) {
			return;
		}

		// find clicked rect by its name
		const name = e.target.name();
		const text = _.find(this.state.textboxes, (r => r.name === name));
		const imageNameMap = { truck : true, trailer : true, car : true };

		if (text || imageNameMap[name]) {
			const selectedShapeType = (text) ? 'text' : 'shape';
			this.setState({
				selectedShapeName: name,
				selectedShapeType,
			});
		} else {
			this.setState({
				selectedShapeName: '',
				selectedShapeType: '',
			});
		}
	};

	getBase64String = ({ callback }) => {
		this.setState({
			selectedShapeName: '',
			selectedShapeType: '',
		}, () => {
			return callback(null, this.stage.toDataURL());
		});
	};

	handleClearDrawing = () => {
		this.baseState.uniqueKey = _.times(20, () => _.random(35).toString(36)).join('');
		this.setState(this.baseState);
	};

	handleDrawClick = () => {
		const { brushMode } = this.state;
		if (brushMode !== 'draw') {
			this.setState({brushMode : 'draw'});
		} else {
			this.setState({brushMode: ''});
		}
	};

	handleEraseClick = () => {
		const { brushMode } = this.state;
		if (brushMode !== 'erase') {
			this.setState({brushMode : 'erase'});
		} else {
			this.setState({brushMode: ''});
		}
	};

	handleHideTruck = () => {
		this.setState({isTruckShowing : false, brushMode: ''});
	};
	handleShowTruck = () => {
		this.setState({isTruckShowing : true, brushMode: ''});
	};
	handleHideTrailer = () => {
		this.setState({isTrailerShowing : false, brushMode: ''});
	};
	handleShowTrailer = () => {
		this.setState({isTrailerShowing : true, brushMode: '' });
	};
	handleHideCar = () => {
		this.setState({isCarShowing : false, brushMode: ''});
	};
	handleShowCar = () => {
		this.setState({isCarShowing : true, brushMode: '' });
	};
	handleAddText = () => {
		const name = _.times(20, () => _.random(35).toString(36)).join('');

		this.setState({
			textboxes : [
				...this.state.textboxes,
				{
					name,
					text: "Double click to edit.\nHit return when done.",
					x : _.random(5, 10),
					y: _.random(5, 10),
					draggable : true,
					fontSize: 20,
				}
			],
			brushMode: '',
		});
	};

	handleTextDoubleClick = (e) => {
		const tr =  this.transformerComponent.transformer;

		const textNode = e.target;
		//const stage = e.target.getStage();
		const layer = e.target.getLayer();

		const stageContainer = this.stageContainer;
		// hide text node and transformer:
		textNode.hide();
		tr.hide();
		layer.draw();

		// create textarea over canvas with absolute position
		// first we need to find position for textarea
		// how to find it?

		// at first lets find position of text node relative to the stage:
		/** @namespace textNode.absolutePosition **/
		//const textPosition = textNode.absolutePosition();
		const textPosition = textNode.absolutePosition();

		// then lets find position of stage container on the page:
		//const stageBox = stage.container().getBoundingClientRect();

		// so position of textarea will be the sum of positions above:
		const areaPosition = {
			//x: stageBox.left + textPosition.x,
			//y: stageBox.top + textPosition.y
			x : textPosition.x,
			y : textPosition.y,
		};


		// create textarea and style it
		const textarea = document.createElement('textarea');
		stageContainer.appendChild(textarea);
		//document.body.appendChild(textarea);

		// apply many styles to match text on canvas as close as possible
		// remember that text rendering on canvas and on the textarea can be different
		// and sometimes it is hard to make it 100% the same. But we will try...
		textarea.value = textNode.text();
		textarea.style.position = 'absolute';
		textarea.style.top = areaPosition.y + 'px';
		textarea.style.left = areaPosition.x + 'px';
		textarea.style.width = textNode.width() - textNode.padding() * 2 + 'px';
		textarea.style.height =
			textNode.height() - textNode.padding() * 2 + 5 + 'px';
		textarea.style.fontSize = textNode.fontSize() + 'px';
		textarea.style.border = '1px dashed blue';
		textarea.style.padding = '0px';
		textarea.style.margin = '0px';
		textarea.style.overflow = 'hidden';
		textarea.style.background = 'none';
		textarea.style.outline = 'none';
		textarea.style.resize = 'none';
		textarea.style.lineHeight = textNode.lineHeight();
		textarea.style.fontFamily = textNode.fontFamily();
		textarea.style.transformOrigin = 'left top';
		textarea.style.textAlign = textNode.align();
		textarea.style.color = textNode.fill();
		textarea.select();

		let rotation = textNode.rotation();
		let transform = '';
		if (rotation) {
			transform += 'rotateZ(' + rotation + 'deg)';
		}

		let px = 0;
		// also we need to slightly move textarea on firefox
		// because it jumps a bit
//		const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
//		if (isFirefox) {
//			px += 2 + Math.round(fontSize / 20);
//		}
		transform += 'translateY(-' + px + 'px)';

		textarea.style.transform = transform;

		// reset height
		textarea.style.height = 'auto';
		// after browsers resized it we can set actual value
		textarea.style.height = textarea.scrollHeight + 3 + 'px';

		textarea.focus();

		function removeTextarea() {
			textarea.parentNode.removeChild(textarea);
			window.removeEventListener('click', handleOutsideClick);
			textNode.show();
			tr.show();
			tr.forceUpdate();
			layer.draw();
		}

		function setTextareaWidth(newWidth) {
			if (!newWidth) {
				// set width for placeholder
				if (textNode.placeholder) {
					newWidth = textNode.placeholder.length * textNode.fontSize();
				}
			}
			// some extra fixes on different browsers
			const isSafari = /^((?!chrome|android).)*safari/i.test(
				navigator.userAgent
			);
			const isFirefox =
				navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
			if (isSafari || isFirefox) {
				newWidth = Math.ceil(newWidth);
			}

			/** @namespace document.documentMode **/
			const isEdge = document.documentMode || /Edge/.test(navigator.userAgent);
			if (isEdge) {
				newWidth += 1;
			}
			textarea.style.width = newWidth + 'px';
		}

		textarea.addEventListener('keydown', function(e) {
			// hide on enter
			// but don't hide on shift + enter
			if (e.keyCode === 13 && !e.shiftKey) {
				textNode.text(textarea.value);
				removeTextarea();
			}
			// on esc do not set value back to node
			if (e.keyCode === 27) {
				removeTextarea();
			}
		});

		textarea.addEventListener('keydown', function() {
			let scale = textNode.getAbsoluteScale().x;
			setTextareaWidth(textNode.width() * scale);
			textarea.style.height = 'auto';
			textarea.style.height =
				textarea.scrollHeight + textNode.fontSize() + 'px';
		});

		function handleOutsideClick(e) {
			if (e.target !== textarea) {
				removeTextarea();
			}
		}
		setTimeout(() => {
			window.addEventListener('click', handleOutsideClick);
		});

	};

	render() {
		const {classes} = this.props;
		const {
			stageWidth, stageHeight, brushMode,
			isTruckShowing, isTrailerShowing, isCarShowing,
			uniqueKey,
		} = this.state;


		const cb = classes.containedButton;
		const ob = classes.outlinedButton;
		const sob = classes.stackedOutlinedButton;
		const scb = classes.stackedContainedButton;
		const tbl = classes.toolButtonLabel;

		return (<div className={classes.drawingContainer} key={uniqueKey}>
			<div className={classes.toolsContainer}>

				{brushMode === 'draw' &&
				<Button variant='contained' color='primary' className={cb}  onClick={this.handleDrawClick}>
					<img alt="Stop Drawing" src={PencilIcon} className={classes.icon}  style={{filter: 'invert(100%)'}}/>
					<span className={tbl}>Draw</span>
				</Button>}
				{brushMode !== 'draw' &&
				<Button variant='contained' className={ob} onClick={this.handleDrawClick}>
					<img alt="Start Drawing" src={PencilIcon} className={classes.icon}/>
					<span className={tbl}>Draw</span>
				</Button>}


				{brushMode === 'erase' &&
				<Button variant="contained" color='primary' className={cb} onClick={this.handleEraseClick}>
					<img alt="Stop Erasing" src={EraserIcon} className={classes.icon} style={{filter: 'invert(100%)'}} />
					<span className={tbl}>Erase</span>
				</Button>}
				{brushMode !== 'erase' &&
				<Button variant='contained' className={ob} onClick={this.handleEraseClick}>
					<img alt="Start Erasing" src={EraserIcon} className={classes.icon}/>
					<span className={tbl}>Erase</span>
				</Button>}

				<Button variant="contained" className={sob} onClick={this.handleAddText}>
					<img alt="Add Text" src={AddTextIcon} className={classes.icon}/>
					<span className={tbl}>Add<br/>Text</span>
				</Button>

				{!isTruckShowing &&
				<Button variant="contained" className={sob} onClick={this.handleShowTruck}>
					<img alt="Eraser" src={TruckIcon} className={classes.icon} style={{transform: 'scaleX(-1)'}}/>
					<span className={tbl}>Add<br/>Truck</span>
				</Button>}
				{isTruckShowing &&
				<Button variant="contained" color='secondary' className={scb} onClick={this.handleHideTruck}>
					<img alt="Remove Truck" src={TruckIcon} className={classes.invertedIcon} />
					<span className={tbl}>Remove<br/>Truck</span>
				</Button>}


				{!isTrailerShowing &&
				<Button variant="contained" className={sob} onClick={this.handleShowTrailer}>
					<img alt="Eraser" src={TrailerIcon} className={classes.icon} style={{transform: 'scaleX(-1)'}}/>
					<span className={tbl}>Add<br/>Trailer</span>
				</Button>}
				{isTrailerShowing &&
				<Button variant="contained" color='secondary' className={scb} onClick={this.handleHideTrailer}>
					<img alt="Remove Trailer" src={TrailerIcon} className={classes.invertedIcon} />
					<span className={tbl}>Remove<br/>Trailer</span>
				</Button>}


				{!isCarShowing &&
				<Button variant="contained" className={sob} onClick={this.handleShowCar}>
					<img alt="Add Car" src={SedanIcon} className={classes.icon} style={{transform: 'scaleX(-1)'}}/>
					<span className={tbl}>Add<br/>Car</span>
				</Button>}
				{isCarShowing &&
				<Button variant="contained" color='secondary' className={scb} onClick={this.handleHideCar}>
					<img alt="Remove Car" src={SedanIcon} className={classes.invertedIcon} />
					<span className={tbl}>Remove<br/>Car</span>
				</Button>}

				<div className={classes.toolbarDivider} />

				<Button variant="contained" className={sob} onClick={this.handleClearDrawing}>
					<DeleteIcon />
					<span className={tbl}>Clear<br/>All</span>
				</Button>
			</div>

			<div id='stageContainer' style={{position : 'relative'}} ref={node => { this.stageContainer = node;}}>

				<ReactResizeDetector handleWidth handleHeight onResize={this.onResize} />
				{stageWidth &&
				<Stage
					container={'#stageContainer'}
					ref={ref => (this.stage = ref)}
					width={stageWidth}
					height={stageHeight}
					onMouseDown={this.handleStageMouseDown}
					onTouchStart={this.handleStageMouseDown}
				>
					<Layer>
						<Rect
							x={0}
							y={0}
							width={stageWidth}
							height={stageHeight}
							fill={'white'}
						/>

						<Drawing
							brushMode={brushMode}
							stageWidth={stageWidth}
							stageHeight={stageHeight}
						/>

						{this.state.textboxes.map((textbox, i) => (
							<Text
								key={i}
								hide={true}
								{...textbox}
								onDblClick={this.handleTextDoubleClick}
								onDblTap={this.handleTextDoubleClick}

							/>
						))}

						{isTruckShowing && <TruckImage />}
						{isTrailerShowing && <TrailerImage />}
						{isCarShowing && <CarImage />}

						<TransformerComponent
							ref={ref => (this.transformerComponent = ref)}
							selectedShapeName={this.state.selectedShapeName}
							selectedShapeType={this.state.selectedShapeType}
						/>
					</Layer>
				</Stage>
				}
			</div>
		</div>);
	}
}

AccidentDrawing.propTypes = {
	classes : PropTypes.object,
	setBase64StringFunction : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
])(AccidentDrawing);